import React from "react";
import { MainNav } from "./CompanyProfileComponents/MainNav";
import { PurchasePlan } from "./PurchasePlanComponents/PurchasePlan";

export const MainPurchasePlan = () => {
  return (
    <view>
      <MainNav />
      <PurchasePlan />
    </view>
  );
};
